/**
 * Ponyfill for [import.meta.resolve](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/import.meta/resolve)
 * until it has a better browser support
 */
export const resolve = (moduleName: string) =>
  // the ["url"] syntax is used to trick Vite to not transpile the `import.meta.url` into the `self.location` during a build
  new URL(moduleName, import.meta["url"])
